<form [formGroup]="formGroup" fxLayout="column" class="filter-form"
  fxLayoutGap="15">
  <div fxLayout="column" fxLayoutAlign="center center">
    <div fxLayout="row" fxLayoutGap="10">
      <ng-content select="[filter-header-buttons]"></ng-content>
    </div>
  </div>
  <div fxLayout="column" fxLayoutGap="6" class="filters">
    <div fxFlex *ngFor="let field of filterFields">
      <app-input [config]="getFieldConfig(field.name)"
        style="width: 100%; height: 70%" [group]="formGroup"
        (onSelect)="getFieldConfig(field.name).onSelect($event)"></app-input>
    </div>
  </div>
  <div>
    <button mat-raised-button type="submit" class="filter-btn"
      (click)="filter()">Filtrar</button>
    <button mat-raised-button type="button"
      style="width: 100%; margin-top: .4rem;" (click)="onClickResetFilter()">
      Limpar Filtros
    </button>
  </div>
  <div fxLayout="column" fxLayoutAlign="center center">
    <h3 style="margin-bottom: 3px"><strong>Exportar filtro</strong></h3>
    <div fxLayout="row" fxLayoutGap="10">
      <button class="file-btn" mat-raised-button color="primary"
        matTooltip="Arquivo PDF"><i
          class="material-icons">picture_as_pdf</i></button>
      <button class="file-btn" mat-raised-button color="primary"
        matTooltip="Arquivo EXCEL"><i
          class="material-icons">description</i></button>
    </div>
  </div>
</form>
